import { render } from "./OtherProfileView.vue?vue&type=template&id=68586d89"
import script from "./OtherProfileView.vue?vue&type=script&lang=js"
export * from "./OtherProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__